<template>
  <div class="lad-summary">
    <client-only v-if="withHighlight">
      <TextHighlight :queries="queries">{{ summary }}</TextHighlight>
    </client-only>
    <template v-else>{{ summary }}</template>

    <div v-if="!search && showActions" :class="actionClasses">
      <nuxt-link
        v-if="hasValidTo"
        :to="to"
        class="el-button el-button--text el-button--small"
      >
        <span>{{ $t('general.show_more') }}</span>
      </nuxt-link>
      <el-button v-else size="small" type="text" @click="handleCollapse">
        <i v-if="!inlineToogle" :class="btnIcon" />
        <span>{{ btnText }}</span>
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LadSummary',
  components: {
    TextHighlight: () => {
      if (process.client) {
        return import(
          /* webpackChunkName: "vue-text-highlight" */ 'vue-text-highlight'
        )
      }
    },
  },
  props: {
    text: { type: String, required: true },
    search: { type: String, default: '' },
    maxLength: { type: Number, default: 250 },
    inlineToogle: { type: Boolean, default: false },
    to: { type: Object, default: () => ({}) },
    // eslint-disable-next-line vue/no-boolean-default
    withHighlight: { type: Boolean, default: true },
  },
  data() {
    return {
      collapsed: false,
    }
  },
  computed: {
    hasValidTo() {
      return Object.keys(this.to).length > 0
    },
    showActions() {
      return this.text.length > this.maxLength
    },
    actionClasses() {
      return [this.inlineToogle ? 'inline-toogle' : '', 'lad-summary--actions']
    },
    summary() {
      if (!this.search && !this.collapsed && this.showActions) {
        const words = this.text.split(' ')

        let summary = ''

        words.every((word) => {
          if (summary.length + word.length <= this.maxLength) {
            summary += ' ' + word
            return true
          } else {
            return false
          }
        })

        return `${summary} ...`
      } else {
        return this.text
      }
    },
    queries() {
      return this.search.split(' ')
    },
    btnIcon() {
      return this.collapsed ? 'el-icon-arrow-left' : 'el-icon-arrow-right'
    },
    btnText() {
      return this.collapsed
        ? this.$t('general.show_less')
        : this.$t('general.show_more')
    },
  },
  methods: {
    handleCollapse() {
      this.collapsed = !this.collapsed
    },
  },
}
</script>

<style lang="scss">
.lad-summary {
  line-height: 1.8;

  span {
    line-height: 1.8;
    display: initial;
  }

  &--actions {
    display: flex;
    justify-content: flex-end;
  }

  .inline-toogle {
    display: inline-block;

    i {
      display: none;
    }
  }
}
</style>
